import React from 'react';
import PropTypes from 'prop-types';
import {
	StyledRadio,
} from './style';

const RadioInput = ({
 id, label, value, onClick, name, checked, justifyContent,
}) => (
	<StyledRadio onClick={onClick} justifyContent={justifyContent}>
		<label className="container-radio">
			<input
				type="radio"
				name={name}
				id={id}
				value={value}
				checked={checked}
			/>
			<span className="checkmark" />
			<span className="label">{label}</span>
		</label>
	</StyledRadio>
);

RadioInput.defaultProps = {
	justifyContent: 'flex-start',
};

PropTypes.RadioInput = {
	id: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]).isRequired,
	label: PropTypes.string.isRequired,
	value: PropTypes.any.isRequired,
	onClick: PropTypes.func.isRequired,
	name: PropTypes.string.isRequired,
	checked: PropTypes.bool.isRequired,
	justifyContent: PropTypes.string,
};

export default RadioInput;
